export default "__VITE_ASSET__CRpqkcgE__"